/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import { Listbox } from '@headlessui/react'
import { CheckIcon } from '@heroicons/react/20/solid'

interface UiTableColumnSelectFilterOption {
    label: string
    value: string | number
}

interface UiTableColumnSelectFilterOptionsListProps {
    options: UiTableColumnSelectFilterOption[]
}

const UiTableColumnSelectFilterOptionsList = (
    props: UiTableColumnSelectFilterOptionsListProps
) => {
    if (!props.options.length) {
        return null
    }

    return (
        <>
            {props.options.map((option) => (
                <Listbox.Option
                    key={option.value}
                    data-value={String(option.value)}
                    className={({ active }) =>
                        clsx(
                            'relative cursor-default select-none py-2 pl-8 pr-4 whitespace-nowrap',
                            active
                                ? 'bg-blue-50 text-blue-600 dark:bg-blue-900/40 dark:text-blue-300'
                                : 'text-gray-900 dark:text-gray-300'
                        )
                    }
                    value={option.value}
                >
                    {({ selected }) => (
                        <>
                            <span
                                className={clsx(
                                    'block truncate',
                                    selected ? 'font-semibold' : 'font-normal'
                                )}
                            >
                                {option.label}
                            </span>
                            {selected ? (
                                <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-blue-600 dark:text-blue-400">
                                    <CheckIcon
                                        className="size-4"
                                        aria-hidden="true"
                                    />
                                </span>
                            ) : null}
                        </>
                    )}
                </Listbox.Option>
            ))}
        </>
    )
}

export default UiTableColumnSelectFilterOptionsList
